import { useParams } from "react-router-dom";

export const useFunnelCreatePageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
